import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../types/store';
import { getActiveSection, getBatchAction, getSelectedRowCount } from '../../selectors/studio';
import { selectBatchAction, cancelBatchAction } from '../../actions/studio';
import { Props } from './MobileBatchEdit';

export type StateProps = Pick<Props, 'activeSection' | 'selectedCount' | 'selectedBatchAction'>;
export type DispatchProps = Pick<Props, 'selectBatchAction' | 'cancelBatchAction'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  activeSection: getActiveSection(state),
  selectedCount: getSelectedRowCount(state),
  selectedBatchAction: getBatchAction(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  selectBatchAction,
  cancelBatchAction,
};

export default connect(mapStateToProps, mapDispatchToProps);
